enum PromoStatus {
  ENDED = 'ENDED',
  PAID = 'PAID',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
}

enum PromoUnitType {
  EXTENDED_TRIAL_MONTHS = 1,
}

type JSONPromo = {
  amount: number;
  code: Maybe<string>;
  currency: string;
  end_date: string;
  is_for_new_user: boolean;
  max_amount: number;
  max_uses: number;
  min_qualify_amount: number;
  min_qualify_units: number;
  offer_text: string;
  percentage: number;
  start_date: string;
  status: PromoStatus;
  terms: null | string;
  unit_type: number;
  units: number;
};

type Promo = {
  amount: number;
  code: Maybe<string>;
  currency: string;
  endDate: string;
  isForNewUser: boolean;
  maxAmount: number;
  maxUses: number;
  minQualifyAmount: number;
  minQualifyUnits: number;
  offerText: string;
  percentage: number;
  startDate: string;
  status: PromoStatus;
  terms: null | string;
  unitType: PromoUnitType;
  units: number;
};

const fromJSON = (jsonPromo: Maybe<JSONPromo>): Maybe<Promo> => {
  if (!jsonPromo) return null;

  return {
    amount: jsonPromo.amount,
    code: jsonPromo.code,
    currency: jsonPromo.currency,
    endDate: jsonPromo.end_date,
    isForNewUser: jsonPromo.is_for_new_user,
    maxAmount: jsonPromo.max_amount,
    maxUses: jsonPromo.max_uses,
    minQualifyAmount: jsonPromo.min_qualify_amount,
    minQualifyUnits: jsonPromo.min_qualify_units,
    offerText: jsonPromo.offer_text,
    percentage: jsonPromo.percentage,
    startDate: jsonPromo.start_date,
    status: jsonPromo.status,
    terms: jsonPromo.terms,
    unitType: jsonPromo.unit_type,
    units: jsonPromo.units,
  };
};

const isValid = (promo: Promo): boolean => {
  const { code, endDate } = promo;
  const promoNotExpired = !endDate || new Date() < new Date(endDate);
  return !!(code && promoNotExpired);
};

export default Promo;

export {
  JSONPromo,
  PromoStatus,
  PromoUnitType,
  fromJSON as promoFromJSON,
  isValid as promoIsValid,
};
